import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { FiPackage, FiPlus } from 'react-icons/fi';
import { Button, PageHeader } from 'components/common';

// The page title bar for the OAuth client list. Uses the app's canonical
// PageHeader rather than a hand-rolled title row, so this screen sits at the
// same altitude as every other list page.
const ApplicationHeader = ({ total }) => {
  const navigate = useNavigate();

  return (
    <PageHeader
      variant="hero"
      icon={FiPackage}
      title="Applications"
      subtitle="OAuth clients that may exchange a secret for a portal token"
      meta={
        total > 0 && (
          <p className="tw-text-xs tw-text-slate-400 tw-mb-0 tw-mt-0.5">
            {total} registered {total === 1 ? 'client' : 'clients'}
          </p>
        )
      }
      actions={
        <Button size="sm" variant="primary" onClick={() => navigate('/integration/applications/new')}>
          <FiPlus size={13} /> New Application
        </Button>
      }
    />
  );
};

ApplicationHeader.propTypes = {
  total: PropTypes.number,
};

export default ApplicationHeader;
